<p>{{'SECTIONS.VAULT_CLEANER.vault-cleaner.DIM_SYNC.TAG_WARNING' | translate: { tag: (('SECTIONS.VAULT_CLEANER.vault-cleaner.DIM_SYNC.TAGS.' + data.tag) | translate) } }}</p>
<p>{{'SECTIONS.VAULT_CLEANER.vault-cleaner.DIM_SYNC.CHOICE' | translate}}</p>

<button class="app-btn" (click)="close(true)">{{'SECTIONS.VAULT_CLEANER.vault-cleaner.DIM_SYNC.APPLY_ALL' | translate}}</button>
<button class="app-btn" (click)="close(false)">{{'SECTIONS.VAULT_CLEANER.vault-cleaner.DIM_SYNC.APPLY_PARTIAL' | translate}}</button>
